/** @format */

import { MobileSubmitViewPropsType } from "../MobileSubmitViewPropsType";
import "../SCSS/styles.css";
import DOMPurify from "dompurify";
import { truncateString } from "../../Common/CommonFunctions/TruncateString";
import images from "../../ImageVariables";
import CheckBox from "../../QuestionTypesComponent/Checkbox";
import StarRating from "../../QuestionTypesComponent/StarRating";
import DropDown from "../../QuestionTypesComponent/DropDown";
import TextBox from "../../QuestionTypesComponent/TextBox";
import Number from "../../QuestionTypesComponent/Number";
import {
  EnumQuestionType,
  EnumSurveyAnswerStatus,
} from "../../Common/Enums/EnumsTypes";
import Radio from "../../QuestionTypesComponent/Radio";
import MobileViewCompanyInfo from "../../MobileViewCompanyInfo";
import MobileViewSupplierInfo from "../../MobileViewSupplierInfo";
import NoteAndGuidance from "../../NoteAndGuidance";
import Tippy from "@tippyjs/react";
import { Navigate } from "react-router-dom";
import DateAndTime from "../../QuestionTypesComponent/DateAndTime";
import Percentage from "../../QuestionTypesComponent/Percentage";
import CustomForm from "../../QuestionTypesComponent/CustomForm";

export default function MobileSubmitView({
  reducerState,
  questionObjVariable,
  surveyAnswers,
  setSurveyAnswers,
  mainRefObject,
  checkNestedDependency,
  isPreview,
  dependencyAnsHash,
  setDependencyAnsHash,
  clearValuesFromSurveyAnswers,
  dispatch,
  surveyAnswersInfo,
  oldOption,
  handleNextPage,
  monthsHash,
  params,
}: MobileSubmitViewPropsType) {
  function renderQuestionTypes(questionId: string) {
    switch (questionObjVariable?.[questionId]?.questionType) {
      case EnumQuestionType.CHECKBOX:
        return (
          <CheckBox
            surveyAnswers={surveyAnswers}
            questionObjVariable={questionObjVariable}
            reducerState={reducerState}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            mainRefObject={mainRefObject}
            checkNestedDependency={checkNestedDependency}
            isPreview={isPreview}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
            dispatch={dispatch}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );

      case EnumQuestionType.RADIO:
        return (
          <Radio
            oldOption={oldOption}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            checkNestedDependency={checkNestedDependency}
            isPreview={isPreview}
            mainRefObject={mainRefObject}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            dispatch={dispatch}
            reducerState={reducerState}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.RATING:
        return (
          <StarRating
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.DROP_DOWN:
        return (
          <DropDown
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            oldOption={oldOption}
            mainRefObject={mainRefObject}
            checkNestedDependency={checkNestedDependency}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            dispatch={dispatch}
            reducerState={reducerState}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.TEXT:
        return (
          <TextBox
            questionId={questionId}
            surveyAnswers={surveyAnswers}
            isPreview={isPreview}
            setSurveyAnswers={setSurveyAnswers}
            mainRefObject={mainRefObject}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.NUMBER:
        return (
          <Number
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.DATE:
        return (
          <DateAndTime
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.PERCENTAGE:
        return (
          <Percentage
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.CUSTOM_FORM:
        return (
          <CustomForm
            surveyAnswers={surveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswersInfo={surveyAnswersInfo}
            dispatch={dispatch}
          />
        );

      default:
        return null;
    }
  }
  const percentage =
    surveyAnswersInfo?.surveyScoreInfo &&
    parseFloat(surveyAnswersInfo?.surveyScoreInfo?.score.toFixed(2)) * 10;

  const classNameImpactTitle = () => {
    if (surveyAnswersInfo?.surveyScoreInfo?.impact === "low") {
      return "impact-low";
    } else if (surveyAnswersInfo?.surveyScoreInfo?.impact === "high") {
      return "impact-high";
    } else if (surveyAnswersInfo?.surveyScoreInfo?.impact === "medium") {
      return "impact-medium";
    } else return "impact-extreme";
  };
  return (
    <>
      <>
        {params ||
        surveyAnswersInfo?.surveyStatus !==
          EnumSurveyAnswerStatus?.COMPLETED ? (
          <div className="mobile-submit-view-main-container">
            <div className="mobile-submit-view-company-info">
              {" "}
              <MobileViewCompanyInfo
                surveyAnswersInfo={surveyAnswersInfo}
                handleNextPage={handleNextPage}
              />
            </div>
            <div className="mobile-submit-view-supplier-info">
              <MobileViewSupplierInfo
                surveyAnswersInfo={surveyAnswersInfo}
                monthsHash={monthsHash}
                handleNextPage={handleNextPage}
              />
            </div>
            <div className="mobile-submit-view-note-and-guidance">
              <NoteAndGuidance
                surveyAnswersInfo={surveyAnswersInfo}
                handleNextPage={handleNextPage}
              />
            </div>
            <div style={{ width: "100%", height: "auto" }}>
              {surveyAnswersInfo?.surveyInfo?.additionalInfo?.showScoreInfo &&
                surveyAnswersInfo?.surveyScoreInfo &&
                surveyAnswersInfo?.surveyStatus !==
                  EnumSurveyAnswerStatus?.REJECTED && (
                  <div className="score-card-cover">
                    <div className="progress-bar-cover">
                      <div className="des">
                        <span>
                          Assessment Score:
                          {surveyAnswersInfo?.surveyScoreInfo?.score.toFixed(2)}
                          /10
                        </span>
                      </div>

                      <div className="progress-bar">
                        <Tippy
                          placement="bottom"
                          content={`${percentage} Percent`}
                          theme="light"
                        >
                          <div
                            style={{
                              width: `${percentage}%`,
                              backgroundColor: "#1EBF9C",
                              height: "100%",
                            }}
                          ></div>
                        </Tippy>
                      </div>
                    </div>
                    <div className="risk-cover">
                      <div className="impact-and-title-heading">
                        <span className="impact-header">IMPACT</span>
                        <span className="impact-title">TITLE</span>
                      </div>
                      <div className="impact-and-title">
                        <div className={classNameImpactTitle()}>
                          <span>
                            {surveyAnswersInfo?.surveyScoreInfo?.impact}

                            <span
                              style={{
                                paddingLeft: "5px",
                              }}
                            >
                              Risk
                            </span>
                          </span>
                        </div>
                        <div className="impact-title">
                          <span>
                            {surveyAnswersInfo?.surveyScoreInfo?.tittle}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>

            {reducerState?.questionIdsToRender?.map(
              (questionId: string, index: number) => {
                return (
                  <div className="mobile-submit-view-inner-wrapper">
                    <div className="mobile-submit-view-all-questions-container">
                      <div className="mobile-submit-view-all-serial-number">
                        {index + 1}.
                      </div>
                      <div className="mobile-submit-view-all-main-question-text">
                        {" "}
                        <span
                          className="mobile-submit-view-all-question-text"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              questionObjVariable?.[questionId]?.question
                            ),
                          }}
                        ></span>
                      </div>
                      {questionObjVariable?.[questionId]?.validation?.mandatory
                        ?.isMandatory && (
                        <span className="mobile-submit-view-all-question-text-is-mandatory">
                          (Mandatory)
                        </span>
                      )}
                    </div>
                    <div className="mobile-submit-view-all-theme-category-cover">
                      {questionObjVariable?.[questionId]?.category && (
                        <div className="mobile-submit-view-all-category-cover">
                          {truncateString(
                            questionObjVariable?.[questionId]?.category.name ||
                              questionObjVariable?.[questionId]?.category,
                            30
                          )}
                        </div>
                      )}
                      {questionObjVariable?.[questionId]?.theme && (
                        <div className="mobile-submit-view-all-theme-cover">
                          {truncateString(
                            questionObjVariable?.[questionId]?.theme,
                            30
                          )}
                        </div>
                      )}
                    </div>
                    {/* custom comps */}
                    <div className="questions-mobile-view-render-questions-container">
                      {renderQuestionTypes(questionId)}
                    </div>

                    {/* render note and attachment  */}
                    {surveyAnswers?.[questionId]?.comment && (
                      <div className="supplier-view-note-cover">
                        <span className="supplier-view-note-header">
                          (Note:
                        </span>
                        <span className="supplier-view-note-content">
                          {surveyAnswers?.[questionId]?.comment}
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                          >
                            )
                          </span>
                        </span>
                      </div>
                    )}

                    <div className="supplier-view-attachment-cover">
                      {surveyAnswers?.[questionId]?.uploads?.map((ele: any) => {
                        return (
                          <div
                            key={ele.Key}
                            className="supplier-view-attachment-img"
                          >
                            <img
                              src={images.pdfSize}
                              alt="pdf"
                              className="supplier-view-attachment"
                            />

                            <div className="supplier-view-attachment-text">
                              {truncateString(ele?.name, 30)}
                            </div>
                            {!EnumSurveyAnswerStatus?.COMPLETED && (
                              <img
                                src={images.download}
                                alt="downloadPdf"
                                className="supplier-view-attachment-pdf-download"
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              }
            )}
          </div>
        ) : (
          <>
            {
              <Navigate
                replace
                to="thankyou"
                state={{ status: surveyAnswersInfo.surveyStatus }}
              />
            }
          </>
        )}
      </>
    </>
  );
}
